export const getPageNumbers = (min: number, max: number) => {
    let pageNumbers = [];

    for (let i = min; i <= max; i++) {
        pageNumbers.push(i);
    }

    return pageNumbers;
};

/**
 * Returns an array of numbers for the middle section of the pagination component
 *
 * @param currentPage
 * @param width The number of pages to show on either side of the current page
 * @returns
 */
export const getMiddlePageNumbers = (currentPage: number, width: number) => {
    let pageNumbers = [];

    for (let i = currentPage - width; i <= currentPage + width; i++) {
        pageNumbers.push(i);
    }

    return pageNumbers;
};
